import { Outlet } from 'react-router-dom'
import { FC } from 'react'

type Props = object

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ContentLayout: FC<Props> = (_props) => {
  return (
    <div className="app">
      <main className="content">
        <Outlet />
      </main>
    </div>
  )
}
